import React, { useContext } from 'react';
import { StyleSheetManager } from 'styled-components';
import { getStyleSheetTarget } from '../utils';
import { ThemeContext } from '../utils/ThemeContext';
import BaseGlobalStyle from './BaseGlobalStyle';
export var GLOBAL_STYLE_DEFAULT_TARGET = '__HZERO-FRONT-UI__CORE__GLOBAL_DEFAULT__';
var GlobalStyle = function GlobalStyle(props) {
  var _useContext = useContext(ThemeContext),
    resolvedTheme = _useContext.resolvedTheme,
    schema = _useContext.schema;
  return /*#__PURE__*/React.createElement(StyleSheetManager, {
    target: getStyleSheetTarget(props.id || GLOBAL_STYLE_DEFAULT_TARGET)
  }, /*#__PURE__*/React.createElement(BaseGlobalStyle, {
    data: resolvedTheme,
    schema: schema,
    css: props.css
  }));
};
export default GlobalStyle;